/**
 * @author Wesley Mascarenhas
 * @version $Id: dataPackValue.model.ts 74884 2017-12-28 14:24:04Z pedro.g.lisboa $
 */
export class DataPackValue {

  public value: string
  public dataPackValueType: string;

  public constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/models/dataPackValue.model.ts